import { z } from 'zod'

import { paginacaoSearchFields, toLimitOffset } from '@/widgets/data-table/table-search'

import type { InboxListParams } from './api'

/**
 * Search params da Caixa de entrada.
 *
 * `status` tem DEFAULT em vez de ser opcional: o backend devolve todos os
 * status, mas a tela é a fila de triagem — abrir em "pendentes" é a decisão de
 * produto. Fica na URL porque "ver meus pendentes" é um link que se manda.
 */
export const caixaDeEntradaSearchSchema = z.object({
  ...paginacaoSearchFields,
  q: z.string().min(1).optional(),
  status: z.enum(['pending', 'processed', 'discarded']).default('pending'),
  ordenar: z
    .enum(['created_at', '-created_at', 'due_date', '-due_date', 'amount', '-amount'])
    .default('-created_at'),
})

export type CaixaDeEntradaSearch = z.infer<typeof caixaDeEntradaSearchSchema>

/**
 * Default do backend: mais recentes primeiro.
 *
 * `created_at` não é uma COLUNA da tabela de propósito — nenhum header exibe a
 * data de criação, então a lista abre sem seta de ordenação. É honesto: a
 * ordem é a do servidor e nenhum header finge estar ordenado. Também é o valor
 * certo para o fallback do `fromSortingState` (3º clique destrava a coluna e a
 * ordem volta a ser exatamente a que o backend aplica sem `order_by`).
 */
export const CAIXA_ORDEM_DEFAULT = '-created_at' satisfies CaixaDeEntradaSearch['ordenar']

/** O status default da triagem — para onde "limpar filtros" devolve a tela. */
export const CAIXA_STATUS_DEFAULT = 'pending' satisfies CaixaDeEntradaSearch['status']

export function toInboxListParams(s: CaixaDeEntradaSearch): InboxListParams {
  return {
    status: s.status,
    ...(s.q !== undefined && { search: s.q }),
    order_by: s.ordenar,
    ...toLimitOffset(s),
  }
}
